export type PasswordStrengthLevel = 'weak' | 'fair' | 'good' | 'strong'

/**
 * Score 0–5 from length and character mix; maps to a bar width and a coarse label.
 */
export function getPasswordStrength(password: string): {
  percent: number
  level: PasswordStrengthLevel
} {
  if (!password) {
    return {percent: 0, level: 'weak'}
  }
  let raw = 0
  if (password.length >= 6) raw++
  if (password.length >= 10) raw++
  if (/[a-z]/.test(password) && /[A-Z]/.test(password)) raw++
  if (/\d/.test(password)) raw++
  if (/[^A-Za-z0-9]/.test(password)) raw++
  const percent = Math.min(100, Math.round((raw / 5) * 100))
  let level: PasswordStrengthLevel
  if (raw <= 1) level = 'weak'
  else if (raw === 2) level = 'fair'
  else if (raw === 3) level = 'good'
  else level = 'strong'
  return {percent, level}
}
